//Uyarı  bir kayıt eklemeden once olup olmadıgını lutfen kontrol ediniz.
export const messages_tr = {
  noaccount: 'Yeni Kullanıcımısınız?',
  google: 'Google ile giris yapin',
  loginwithsocial:
    'Veya sosyal kullanıcı billgilerinizle de giriş yapabilirsiniz',
  linkden: 'LinkedIn ile giris yapin',
  login: 'Giriş',
  loginm: 'Giriş',
  signupm: 'Kayıt',
  firstname: 'Ad',
  lastname: 'Soyad',
  email: 'Eposta',
  password: 'Şifre',
  pickpassowrd: 'Şifre Belirleyin',
  onelower: 'En az bir küçük karakter',
  oneuppercase: 'En az bir büyük karakter',
  onenumeric: 'En az bir numara',
  mineightchar: 'Minimum 8 karakter',
  suggest: 'Öneriler',
  howdidfind: 'Bize nerden ulaştız?',
  agreement: 'Linkte belirtilen şartlar ve koşulları okudum kabul ediyorum',
  terms: ' Şartlar ve Koşullar',
  hasaccount: 'Daha önce hesap açtınızmı?',
  uyari: 'Uyarı',
  definations: 'Tanımlar',
  cstatus: 'Aday Durumları',
  elevels: 'Eğitim Seviyeleri',
  topTypes: 'Eğitim Tanımları',
  toptypes: 'İş Tanımları',
  jobStatus: 'İş Durumları',
  jobIndus: 'Endüstriler',
  jobLocations: 'Lokasyonlar',
  jobSalary: 'Maaş Türleri',
  profile: 'Profil',
  changeMyPassword: 'Şifremi güncelle',
  help: 'Yardim',
  logout: 'Çikiş',
  dashboard: 'Ana Ekran',
  arama: 'Kelime Arama',
  id: 'ID',
  description: 'Açıklama',
  edulevel: 'İş Durumları',
  action: 'Aksiyonlar',
  addrecord: 'Yeni bir kayıt ekle',
  search: 'Arama Yap...',
  location: 'Lokasyonlar',
  delete: 'Sil',
  edit: 'Değiştir',
  linkedInEmail: 'LinkedIn eposta',
  signupError: 'Bu Linkedin addresi oncedden kayit edilmis',
  vieworder: 'Sıra Durumu',
  hometitle:
    'Hayalini kurduğunuz işe basvurabilir yada arkaşınıza referans olabilirsiniz ',
  locationm: 'Lokasyon',
  keyword: 'Kelime',
  findjob: 'İş Ara',
  enterkeyword: 'Kelime Girin',
  enterlocation: 'Lokasyon Girin',
  home: 'Ana Sayfa',
  contactus: 'İletişim Bilgileri',
  getstarted: 'Hemen Başla',
  filter: 'Filtreler',
  jobtype: 'Meslek Türü',
  worktype: 'Çalışma Tipi',
  dateposted: 'Gönderim Tarihi',
  alljobs: 'Tüm İş Türleri',
  fulltime: 'Tam zamanlı',
  partime: 'Yarı Zamanlı',
  remote: 'Uzaktan Çalışma',
  onside: 'Ofiste',
  thisweek: 'Bu Hafta',
  today: 'Bugün',
  contract: 'Sözleşmeli',
  hybrid: 'Hibrit',
  thismonth: 'Bu Ay',
  temporary: 'Geçici',
  internship: 'Staj',
  any: 'Herhangi Biri',
  clear: 'Filtreyi Temizle',
  result: 'Sonucu Göster',
  name: 'İlan Başlığı',
  companyName: 'Şirket İsmi',
  reward: 'Ödül',
  createDate: 'Yayınlama Tarihi',
  refer: 'Refer',
  apply: 'Apply',
  recruitment: 'Recruitment  Redefined!',
  about: 'Hakkında',
  resources: 'Kaynaklar',
  legal: 'Yasal',
  company: 'Şirket',
  howitworks: 'Nasıl Çalışır?',
  privacy: 'Gizlilik Politikası',
  contact: 'Bizim ile iletişime geçin',
  termsofservice: 'Hizmet şartları',
  copyright: 'Telif Hakkı @Crowd Hr 2023 Bütün Hakları Saklıdır',
  contractor: 'Müteahhit',
  alljob: 'Tüm İşler',
  subtitle:
    'Hayalinizdeki İşe başvurun veya arkadaşınıza yönlendirerek ödül kazanın',
  getCandidateHired: 'Adayınız işe alındığında ödülü alacaksınız.',
  workingMultipleCompanies:
    'Birden fazla şirket için çalışmak hiç bu kadar kolay olmamıştı.',
  uploadCV: 'Adayınızın özgeçmişini yükleyin.',
  uploadingCV: 'Adayınızın özgeçmişini yükleyerek adayınızı yönlendirin.',
  recruitProcess: 'İşe alım sürecini takip edin',
  recruitmenProcess:
    'Tüm adaylarınızın işe alım süreçlerini kolayca takip edin.',
  getReward: 'Ödülünüzü alın',
  gettingReward: 'Adayınız işe alındığında ödül miktarını alın.',
  companyRegister:
    'Şirketinizin açık pozisyonları için ücretsiz bir tur başlatın',
  companyInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  recruiterRegister: 'RECRUITER OLARAK KULLANMAYA BAŞLAYIN',
  clientRegister: 'ADAY OLARAK KULLANMAYA BAŞLAYIN',
  companyButton: 'Şirket İçin Ücretsiz Başlangıç',
  recruiterButton: 'Recruiter İçin Ücretsiz Başlangıç',
  clientButton: 'Aday İçin Ücretsiz Başlangıç',
  sektor: 'SEKTÖR',
  genelnitelik: 'GENEL NİTELİKLER',
  istanimi: 'İŞ TANIMI',
  odul: 'ÖDÜL',
  yayintarih: 'Yayınlanma Tarihi',
  gorunme: 'Görüntülenme',
  benzerisler: 'Benzer İşler',
  recruiter: 'İşe Alım Uzmanı',
  mesagtorec: 'İşverene mesaj',
  fullname: 'İsim',
  linkedinPage: 'Linkedin Page',
  role: 'Rol',
  users: 'Kullanıcılar',
  userList: 'Kullanıcı Listesi',
  logo: 'Logo',
  industry: 'Endüstri',
  website: 'Website',
  phone: 'Telefon',
  accManager: 'Muhasebe Müdürü',
  companies: 'Şirketler',
  companyList: 'Şirket Listesi',
  cancel: 'Vazgeç',
  save: 'Kayıt',
  companyedit: 'Şirket Düzenlemek',
  aphone: 'Alternatif Telefon Numarası',
  nemail: 'Bildiri Emaili ',
  addlogo: 'Logo ekle (PDF, JPG, PNG)',
  address: 'Adres',
  selectCity: 'Şehir Seçimi',
  selectCountry: 'Ülke Seçimi ',
  state: 'Eyalet / İlçe / Bölge',
  zipcode: 'Posta kodu',
  taxid: 'Vergi Numarasi',
  taxoffice: 'Vergi Ofisi',
  billaddress: 'Fatura Adresi',
  sameAs: 'Şirket Adresi ile aynı olsun',
  NeedHelp: 'Yardım?',
  forgotPassword: 'Şifremi Unuttum?',
}
